import { FormControl, Autocomplete, TextField } from "@mui/material";
import * as React from "react";
import { connect, useDispatch } from "react-redux";
import {
  USER_DATECHANGEINICIO_STATE_CHANGE,
  USER_DATECHANGEFINAL_STATE_CHANGE,
} from "../../../redux/constanst";
import {
  getFecha,
  getFechaRango,
  mapStateToProps,
  tags,
} from "../models/buscar";

function CustomizedSelects(props) {
  const dispatch = useDispatch();
  const cambiarFecha = async (e) => {
    if (e === tags[0]) {
      const dateTime2 = getFecha();
      let dateTime = {
        inicio: {
          dia: dateTime2[0][0],
          mes: dateTime2[0][1],
          year: dateTime2[0][2],
        },
        final: {
          dia: dateTime2[1][0],
          mes: dateTime2[1][1],
          year: dateTime2[1][2],
        },
      };

      await dispatch({
        type: USER_DATECHANGEINICIO_STATE_CHANGE,
        dateChangeInicio: dateTime.inicio,
      });
      await dispatch({
        type: USER_DATECHANGEFINAL_STATE_CHANGE,
        dateChangeFinal: dateTime.final,
      });
    } else {
      const dateTime2 = getFechaRango();
      let dateTime = {
        inicio: {
          dia: dateTime2[0][0],
          mes: dateTime2[0][1],
          year: dateTime2[0][2],
        },
        final: {
          dia: dateTime2[1][0],
          mes: dateTime2[1][1],
          year: dateTime2[1][2],
        },
      };

      dispatch({
        type: USER_DATECHANGEINICIO_STATE_CHANGE,
        dateChangeInicio: dateTime.inicio,
      });
      dispatch({
        type: USER_DATECHANGEFINAL_STATE_CHANGE,
        dateChangeFinal: dateTime.final,
      });
    }
  };
  return (
    <div>
      {
        <FormControl sx={{ m: 0.7 }} variant="standard">
          <Autocomplete
            size="small"
            disablePortal
            id="combo-box-demo"
            options={tags}
            onChange={(event, value) => cambiarFecha(value)}
            sx={{ width: 200, maxWidth: 250 }}
            renderInput={(params) => <TextField {...params} label={tags[0]} />}
          />
        </FormControl>
      }
    </div>
  );
}

export default connect(mapStateToProps, null)(CustomizedSelects);
